export enum MenuStates {
	INACTIVE = 'Nieaktywne',
	ACTIVE = 'Aktywne',
}
